import Env from "../Env";
import Request from "./Request";

export default class GenerationRequest extends Request {

  static loadAllPages(handlerSuccess, handlerError, handlerComplete) {
    const url = Env.getBackendURL() + 'page/get_everything';
    Request.load(url, handlerSuccess, handlerError, handlerComplete);
  }

  static loadConditions() {
    return Request.loadR(Env.getBackendURL() + 'config/load_conditions');
  }

  static loadMentions() {
    return Request.loadR(Env.getBackendURL() + 'config/load_replacements');
  }

  static loadAllTemplates(handlerSuccess, handlerError, handlerComplete) {
    const url = Env.getBackendURL() + 'templates';
    Request.load(url, handlerSuccess, handlerError, handlerComplete);
  }

  /**
   * @param data
   * @returns {Promise<Response>}
   */
  static savePage(data) {
    const url = Env.getBackendURL() + 'page/save';
    return Request.submitR(url, data);
  }

  /**
   * @param data
   * @returns {Promise<Response>}
   */
  static publish(data) {
    const url = Env.getBackendURL() + 'page/publish';
    return Request.submitR(url, data);
  }

  // Remove fetchPageTemplate
}
